import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/linkard_logo.png'
import _imports_1 from '../assets/images/my-link-default.svg'
import _imports_2 from '../assets/images/my-card-default.svg'
import _imports_3 from '../assets/images/my-cabinet.svg'
import _imports_4 from '../assets/images/share_linkard_icon.svg'
import _imports_5 from '../assets/images/close.png'


const _withScopeId = n => (_pushScopeId("data-v-074c0c39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-wrapper" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "linkard_name linkard_en_name" }, "LINKARD", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "linkard_name" }, "联卡", -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "label-wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "card_jump_action"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "card_img",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联卡", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "card_img",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "卡包", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "card_img",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "卡柜", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(['linkard_link_site_bg'])
}
const _hoisted_19 = { class: "top-site-info" }
const _hoisted_20 = {
  key: 0,
  class: "cannot_input_tips"
}
const _hoisted_21 = { class: "pop-wrapper" }
const _hoisted_22 = { class: "link-address-wrapper" }
const _hoisted_23 = { class: "text" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  slot: "reference",
  class: "share-btn"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "share_linkard_icon",
    src: _imports_4,
    alt: ""
  })
], -1))
const _hoisted_25 = { class: "pop-wrapper mine-pop-wrapper" }
const _hoisted_26 = {
  class: "avatar",
  slot: "reference"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "login-wrapper" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "qrcode-container",
  class: "erweima"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "privacy_agreement" }, [
  /*#__PURE__*/_createElementVNode("span", null, "扫码即代表您同意"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://o4ernlf37o.feishu.cn/file/Zk3JbG6N5oUEfExRWwjchdqcnUg?from=from_copylink",
      target: "_blank"
    }, "《用户协议》")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "与"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://o4ernlf37o.feishu.cn/file/EW6Lb8Iu4o6LHpx7PDYc6R5SnQb?from=from_copylink",
      target: "_blank"
    }, "《隐私政策》")
  ])
], -1))
const _hoisted_31 = { class: "logout-wrapper" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "是否确认登出？", -1))
const _hoisted_33 = { class: "poster_bg" }
const _hoisted_34 = {
  ref: "canvasRef",
  class: "linkard_item_bg"
}
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "linkard_name" }
const _hoisted_37 = { class: "linkard_tags" }
const _hoisted_38 = { class: "linkard_tags_bg" }
const _hoisted_39 = { class: "linkard_avatar" }
const _hoisted_40 = { class: "linkard_path" }
const _hoisted_41 = { class: "qr_code_image_bg" }
const _hoisted_42 = { class: "download_qr_code_image_bg" }
const _hoisted_43 = {
  ref: "qrcodeGeneratorDownloadRef",
  class: "download_qr_code_image"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!
  const _component_UserinfoView = _resolveComponent("UserinfoView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "logo-wrapper",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gotoHome && _ctx.gotoHome(...args)))
      }, _hoisted_6),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.showTopRoutTab)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass(['f-btn', (_ctx.currentRoutePath == '/editCard' || _ctx.currentRoutePath == '/enterpriseEdit') ? 'f-btn-active' : '']),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toLinkard && _ctx.toLinkard(...args)))
              }, _hoisted_11, 2),
              _createElementVNode("div", {
                class: _normalizeClass(['f-btn', _ctx.currentRoutePath == '/collect' ? 'f-btn-active' : '']),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toCardCollect && _ctx.toCardCollect(...args)))
              }, _hoisted_14, 2),
              (_ctx.haveCabinet)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['f-btn', _ctx.currentRoutePath == '/cabinet' ? 'f-btn-active' : '']),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toCabinet && _ctx.toCabinet(...args)))
                  }, _hoisted_17, 2))
                : _createCommentVNode("", true),
              (_ctx.currentRoutePath == '/editCard')
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.baseLinkUrl + '/' + _ctx.splitLinkardPath), 1),
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.linkardPath,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.linkardPath) = $event)),
                        disabled: !_ctx.pathAllowChanges,
                        onBlur: _ctx.linkInputBlurChange,
                        onFocus: _ctx.linkInputFocusChange
                      }, null, 8, ["modelValue", "disabled", "onBlur", "onFocus"]),
                      (!_ctx.pathAllowChanges)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, "* 暂不可修改"))
                        : _createCommentVNode("", true),
                      (_ctx.pathAllowChanges && _ctx.linkInputFocus)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "change_btn",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.linkardSavePathRequest && _ctx.linkardSavePathRequest(...args)))
                          }, " 修改 "))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_el_popover, {
                      placement: "bottom",
                      trigger: "hover"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", {
                            class: "pop-next-btn",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toShowPost && _ctx.toShowPost(...args)))
                          }, "我的海报"),
                          _createElementVNode("div", {
                            class: "pop-next-btn",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toShowErweima && _ctx.toShowErweima(...args)))
                          }, "我的二维码"),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.baseLinkUrl + '/' + _ctx.splitLinkardPath + _ctx.linkardPath), 1),
                            _createElementVNode("div", {
                              class: "copy-btn",
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args)))
                            }, "点击复制")
                          ])
                        ])
                      ]),
                      reference: _withCtx(() => [
                        _hoisted_24
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.currentRoutePath == '/login')
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "login_btn",
          onClick: _ctx.loginButtonClick
        }, {
          default: _withCtx(() => [
            _createTextVNode("登录")
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.currentRoutePath != '/login' && _ctx.currentRoutePath != '/managementCenterView')
      ? (_openBlock(), _createBlock(_component_el_popover, {
          key: 1,
          placement: "bottom-end",
          trigger: "hover"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              (_ctx.hasUserPhone)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "pop-next-btn",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toManagerLinkardView && _ctx.toManagerLinkardView(...args)))
                  }, " 管理中心 "))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "pop-next-btn",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showUserManual && _ctx.showUserManual(...args)))
              }, "使用手册"),
              _createElementVNode("div", {
                class: "pop-next-btn",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.logOutButtonClick && _ctx.logOutButtonClick(...args)))
              }, "立即登出")
            ])
          ]),
          reference: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("img", {
                src: _ctx.currentUserHeader ? _ctx.currentUserHeader : _ctx.userDefaultHeader,
                alt: ""
              }, null, 8, _hoisted_27)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.loginQRVisible,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.loginQRVisible) = $event)),
      "show-close": false,
      "align-center": "",
      center: "",
      "before-close": _ctx.handleBeforeClose
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("img", {
            src: _imports_5,
            alt: "",
            class: "close_qr",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeQRView && _ctx.closeQRView(...args)))
          }),
          _hoisted_30
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.logoutShow,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.logoutShow) = $event)),
      "show-close": false,
      "align-center": "",
      center: ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", {
            class: "btn btn-confirm",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
          }, "登出"),
          _createElementVNode("div", {
            class: "btn",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeLogout && _ctx.closeLogout(...args)))
          }, "返回")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.postShow,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.postShow) = $event)),
      "show-close": false,
      "align-center": "",
      center: ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("img", {
              src: _ctx.currentLinkInfo.logo,
              alt: "",
              class: "linkard_logo"
            }, null, 8, _hoisted_35),
            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.currentLinkInfo.name), 1),
            _createElementVNode("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentLinkInfo.tags, (item, index) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  item
                    ? (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(item), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 256))
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_el_image, {
                src: _ctx.currentLinkInfo.avatar,
                fit: "cover"
              }, null, 8, ["src"])
            ]),
            _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.baseLinkUrl + '/' + _ctx.splitLinkardPath + _ctx.linkardPath), 1),
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_vue_qrcode, {
                value: _ctx.linkardQRImgUrl,
                color: {},
                type: "image/png",
                width: 106,
                height: 106,
                margin: 2,
                errorCorrectionLevel: "L"
              }, null, 8, ["value"])
            ])
          ], 512),
          _createElementVNode("div", {
            class: "btn btn-confirm btn-post",
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.createPoster && _ctx.createPoster(...args)))
          }, " 下载PNG ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.qRCodeShow,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.qRCodeShow) = $event)),
      "show-close": false,
      "align-center": "",
      center: ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_vue_qrcode, {
              value: _ctx.linkardQRImgUrl,
              color: {},
              type: "image/png",
              width: 306,
              height: 306,
              margin: 2,
              errorCorrectionLevel: "L"
            }, null, 8, ["value"])
          ], 512),
          _createElementVNode("div", {
            class: "btn btn-confirm btn-post",
            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.downLoadQRImage && _ctx.downLoadQRImage(...args)))
          }, " 下载PNG ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showUserInfoDialog,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.showUserInfoDialog) = $event)),
      "show-close": false,
      "align-center": "",
      center: ""
    }, {
      header: _withCtx(() => [
        _createVNode(_component_UserinfoView, { onCloseUserView: _ctx.closeUserInfoDialog }, null, 8, ["onCloseUserView"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}